import React from 'react';

interface OpenInNewTabProps {
    color?: string;
}

const OpenInNewTab = ({
    color
}: OpenInNewTabProps) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.66667
                16.5H15.9C16.2314
                16.5
                16.5
                16.2314
                16.5
                15.9V2.1C16.5
                1.76863
                16.2314
                1.5
                15.9
                1.5H2.1C1.76863
                1.5
                1.5
                1.76863
                1.5
                2.1V12.3333"
                stroke={color || "#404040"}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round" />
            <path
                d="M1.91602
                16.0833L8.99935
                9M8.99935
                9V12.3333M8.99935
                9H5.66602"
                stroke={color || "#404040"}
                strokeWidth="1.2"
                strokeLinecap="round" 
                strokeLinejoin="round" />
        </svg>
    );
};

export default OpenInNewTab;
